/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsManagementDeleteNewsResponse } from './NewsManagementDeleteNewsResponse';

export type NewsManagementDeleteNewsResponseApiRespoonse = {
    data?: NewsManagementDeleteNewsResponse;
    status?: NewsManagementDeleteNewsResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace NewsManagementDeleteNewsResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

